import React from 'react';
import { ChevronDown, ChevronRight, CheckCircle } from 'lucide-react';
import { Typography } from '@crisellevaldez/speculo-ui';

interface FubAccordionStepProps {
  stepNumber: number;
  title: string;
  isOpen: boolean;
  isCompleted: boolean;
  canOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const FubAccordionStep: React.FC<FubAccordionStepProps> = ({
  stepNumber,
  title,
  isOpen,
  isCompleted,
  canOpen,
  onToggle,
  children,
}) => {
  // Determine the background color based on step status
  const getBgColor = () => {
    if (isCompleted) return 'bg-green-100 dark:bg-green-900/20 text-green-600 dark:text-green-400';
    if (canOpen) return 'bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400';
    return 'bg-gray-100 dark:bg-white/10 text-gray-400';
  };

  return (
    <div className="mb-4">
      <div
        className={`flex items-center p-3 mb-2 cursor-pointer border border-gray-200 dark:border-white/15 rounded-md shadow-sm ${
          !canOpen && 'opacity-60'
        } ${isOpen ? 'bg-gray-50 dark:bg-white/5' : 'bg-white dark:bg-white/[0.02]'} hover:bg-gray-50 dark:hover:bg-white/5 hover:shadow-md transition-all duration-150`}
        onClick={() => canOpen && onToggle()}
      >
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center mr-2 ${getBgColor()}`}
        >
          {stepNumber}
        </div>
        <Typography variant="h5" className="font-semibold flex-grow">
          {title}
          {isCompleted && <CheckCircle className="ml-2 h-5 w-5 text-green-500 inline-block" />}
        </Typography>
        {canOpen &&
          (isOpen ? (
            <ChevronDown className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          ) : (
            <ChevronRight className="h-5 w-5 text-gray-500 dark:text-gray-400" />
          ))}
      </div>

      {isOpen && <div className="p-4 mt-2">{children}</div>}
    </div>
  );
};
